import { withHTMLComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';

const html = `<span id="hoverLabel"></span><slot></slot>`;

export default class ContentContainer extends withHTMLComponent(
  styles,
  html
)() {
  static get observedAttributes() {
    return ['hover'];
  }

  constructor() {
    super();
    this._label = this.shadowRoot.querySelector('#hoverLabel');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'hover') {
      this._label.textContent = newValue;
    }
  }
}

customElements.define('upd-moveiq-content-container', ContentContainer);
